<template>
  <div>
    <div class="display-4">SuperForm</div>
    <div class="my-5"></div>
    <CRow align-horizontal="center">
      <CCol col="8">
        <CRenderFunction flat :content-to-render="nav"/>
      </CCol>
    </CRow>
    <div class="my-5"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import nav from './_dashboard_nav'
import admin_nav from './_admin_dashboard_nav'
import DashboardTiles from '../components/DashboardTiles'
Vue.component('DashboardTiles', DashboardTiles);
import DashboardTile from '../components/DashboardTile'
Vue.component('DashboardTile', DashboardTile);

export default {
  name: 'Dashboard',
  data () {
    return {
      nav: (this.$store.getters.isAdmin ? admin_nav : nav),
    }
  },
  methods: {}
}
</script>
